import axios from 'axios'
import { Toast } from 'vant'
import store from '@/store'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/dev-api',
  timeout: 20000
})

service.interceptors.request.use(config => {
  const token = store.state.token
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

function toError(payload) {
  const msg = (payload && (payload.msg || payload.message)) || 'Error'
  const err = new Error(msg)
  err.code = payload && payload.code
  err.data = payload
  return err
}

service.interceptors.response.use(
  res => {
    const data = res.data || {}
    if (data.code === 200) {
      return data
    }
    const msg = data.msg || 'Error'
    Toast.fail(msg)
    if (data.code === 401) {
      store.commit('CLEAR_AUTH')
      router.replace('/login')
    }
    return Promise.reject(toError(data))
  },
  err => {
    const msg = (err.response && err.response.data && err.response.data.msg) || err.message || 'Network Error'
    Toast.fail(msg)
    return Promise.reject(toError({ msg, code: err.response && err.response.status }))
  }
)

export default service
